import { Injectable, Inject } from '@angular/core';
import { DataProvider, ParameterService, Widget, TimelineSeries, TimelineData, Series, DashboardConfigManager, AuthService, LogService, Border, KeyValue } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { empty, Subscription, forkJoin, Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { SubscriptionWsi, ValueDetails, WSIValueService } from 'core-dashboard';

@Injectable()
export class DesigoCCTrendSeriesProvider implements DataProvider {
    pointNames: any[] = [];
    clientID: string;
    _subscriptionInfoPerRequestedObjectOrPropertyId: Map<string, SubscriptionWsi>;
    valuesSubscription: Subscription;
    errorMessage: any;
    isLive: boolean = true;
    widget: Widget;
    config: any;
    seriesids: string[] = undefined;
    isDataNotPresent = false;
    xAxisScaleToMaintain: Date[];
    scaleToMaintainForNonArchievedData = 15 * 60000;
    cachedDataToMaintain = 12 * 60 * 60 * 1000;//2*60*1000;//maintain 12 hrs of data for Non Archived data points
    isZoomCalled: boolean = false;
    seriesid: any = undefined;
    trendobj: any = undefined;
    From: any = undefined;
    To: any = undefined;
    Interval: any = undefined;
    DefaultInterval: number = 1000;
    LoadDataForDays: number = 0;
    widgetDrawn: boolean = false;
    dataPointName: Array<KeyValue> = [];
    private unit: string = "";
    private resolution: number;
    StartDate: string = undefined;
    EndDate: string = undefined;
    LBorder: string = undefined;
    RBorder: string = undefined;
    private lBorder: any[] = [];
    private rBorder: any[] = [];
    private calculatedInterval: any;
    //private intervalParam:any;
    private intervalArray: any[] = [];
    private missedData: TimelineSeries[] = [];

    timelineData: TimelineData = undefined;

    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private logger: LogService,
        private dashboardConfig: DashboardConfigManager,
        private valueService: WSIValueService) {
    }

    getData(w: Widget) {
        this.widget = w;
        this.config = this.widget.getConfig();
        try {
            this.isZoomCalled = false;
            if (this.config == undefined) {
                this.logger.logWarning("TrendSeriesDataProvider", " Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response: HttpResponse<any>) => {
                        if (response) {
                            //Get the config info
                            this.initializeConfig();
                            //let t1 = performance.now();
                            //console.log("timer 1: " + t1);
                            this.CreateSubscription();
                            //let t2 = performance.now();
                            //console.log("timer 2: " + (t2 - t1));
                            //setTimeout(function () {
                            this.Start();
                            //}, 1);
                        }
                    }, error => {

                        //this code will get executed when base URL path is inccorrect
                        this.logger.logWarning("TrendSeriesDataProvider", "TrendSeriesDataProvider can not login to desigo cc.");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.initializeConfig();
                //let t1 = performance.now();
                //console.log("timer 1: " + t1);    
                this.CreateSubscription();
                //let t2 = performance.now();
                //console.log("timer 2: " + (t2 - t1));
                //setTimeout(function () {
                this.Start();
                //}, 1);
            } else {
                this.logger.logWarning("TrendSeriesDataProvider", "TrendSeriesDataProvider can not login to desigo cc.");
                this.widget.Draw(null);
            }

        }
        catch (error) {
            this.logger.logError('TrendSeriesDataProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }
    private CreateSubscription() {
        this.logger.logInfo(DesigoCCTrendSeriesProvider.name + ":GetObjectValue", "Subscribed for Events");
        if (this.clientID === undefined) {
            this._subscriptionInfoPerRequestedObjectOrPropertyId = new Map<string, SubscriptionWsi>();
            this.clientID = this.valueService.createClientId(DesigoCCTrendSeriesProvider.name);
            //How we process indications when they come up.  This does NOT actually subscribe for value changes on any object
            this.valuesSubscription = this.valueService.valueChangeNotification(this.clientID).subscribe(
                (valueDetails) => this.onValueChange(valueDetails), error => this.errorMessage = <any>error
            );
        }
        //this.pointNames = ['System5:GmsDevice_1_910_1.Present_Value:_offline.._value', 'System5:GmsDevice_1_910_2.Present_Value:_offline.._value', 'System5:GmsDevice_1_910_3.Present_Value:_offline.._value'];
        let ids: string[] = this.seriesids.slice(0, this.seriesids.length);//this.seriesids;// this.pointNames;//[this.pointName, 'System5:GmsDevice_1_910_2', 'System5:GmsDevice_1_910_3'];
        // for(let i =0; i<= ids.length -1; i++){
        //     let ind = ids[i].lastIndexOf(":_offline.._value");
        //     if(ind != -1){
        //         ids[i] = ids[i].substring(0, ind);
        //     }
        // }
        this.valueService.subscribeValues(ids, true, this.clientID).subscribe(
            (subscriptions) => this.onSubscribeValues(subscriptions, ids), error => this.errorMessage = <any>error
        );
    }
    private onValueChange(valuesDetails: ValueDetails[]): void {
        //add data to missed data on pause
        let newData = valuesDetails[0];
        this.missedData.forEach(series => {
            if (series.TrendSeriesId.indexOf(newData.OriginalObjectOrPropertyId) > -1) {
                let x: any = newData.Value.Timestamp;
                let y: any = newData.Value.Value;

                let seriesItem = new Series();
                seriesItem.X = new Date(x);
                seriesItem.Y = new Number(y);
                series.Series.push(seriesItem);
            }
        });
    }

    private onSubscribeValues(subscriptions: SubscriptionWsi[], properties: string[]): void {
        properties.forEach((value, index, array) => {
            this.logger.logInfo(DesigoCCTrendSeriesProvider.name + ":onSubscribeValues", value);
            if (subscriptions[index].ErrorCode === 0) {
                if (subscriptions[index] != undefined) {
                    this._subscriptionInfoPerRequestedObjectOrPropertyId.set(subscriptions[index].OriginalObjectOrPropertyId, subscriptions[index]);
                }
            }
        });
    }
    private isThisNonArchivedNona(trendId: string, nonArchivedTimelineData: TimelineData) {
        let isAnyNonArchivedTrend = false;
        for (let tCount = 0; tCount < nonArchivedTimelineData.Data.length; tCount++) {
            if (nonArchivedTimelineData.Data[tCount].TrendSeriesId == trendId && nonArchivedTimelineData.Data[tCount].IsNonArchived) {
                isAnyNonArchivedTrend = true;
                break;
            }
        }
        return isAnyNonArchivedTrend;
    }
    getReducedCovData(tData: any) {
        let isOnlyNonArchived: boolean = tData.isOnlyNonArchived;
        let nonArchivedTimelineData: TimelineData = tData.NonaTrends;
        let originalLBorder;
        let isItFrom: string = tData.isItFrom
        let reducedData: { data: any, isAllItems: boolean, numberOfItemsToRemove: number[], borders: any[], xAxisScaleToMaintain: Date[] } = { data: tData.data, isAllItems: true, numberOfItemsToRemove: [], borders: [], xAxisScaleToMaintain: undefined };
        let seriesIndex = 0;
        let isToMaintainDuplicateBorders = false;
        let duplicateBorders;
        try {
            //if the there is huge gap in data to show(right xAxisSxale) and COV, then it means we dont want to show the missed data in cahrt and we just want to get reduced data
            //if user zoomed in/out on left side of chart
            for (var _serCount = 0; _serCount < this.missedData.length; _serCount++) {
                //2000 added in case of combination of archived and non archived trends and we always have archived trend older data as it is coming from HDB and we have latest COV's
                if (isOnlyNonArchived && this.missedData[_serCount].Series.length > 0 && this.xAxisScaleToMaintain.length > 0 && this.missedData[_serCount].Series[this.missedData[_serCount].Series.length - 1].X > new Date(this.xAxisScaleToMaintain[1].getTime() + 2000)) {
                    isToMaintainDuplicateBorders = true;
                    duplicateBorders = { lBorder: this.lBorder.slice(0, this.lBorder.length), rBorder: this.rBorder.slice(0, this.rBorder.length), xAxisScaleToMaintain: this.xAxisScaleToMaintain.slice(0, this.xAxisScaleToMaintain.length) };
                    break;
                }
            };

            //1. for each series of missed data
            this.missedData.forEach(series => {
                let isToreduceSeries: boolean;
                let isBorderChanged = false;
                //IF to reduce only archived & the series is also non archived
                if (isOnlyNonArchived && (series.IsNonArchived || this.isThisNonArchivedNona(series.TrendSeriesId, nonArchivedTimelineData))) {
                    isToreduceSeries = true;

                    //this case is mainly applicable for start and refresh
                    if (isItFrom == "START" || isItFrom == "REF") {
                        let isBUpdated = false;
                        tData.data.Data.forEach(ser => {
                            if (series.TrendSeriesId == ser.TrendSeriesId && ser.xMax != undefined) {
                                this.rBorder[seriesIndex] = ser.xMax.getTime();
                                isBUpdated = true;
                            }
                        });
                        if (isBUpdated) {
                            //if rBorder is updated then, keep the lBorder backup and reset it to original again in the end
                            if (originalLBorder == undefined)
                                originalLBorder = this.lBorder;
                        }
                        //if rBorder is not updated, then set rBorder = lBorder
                        else
                            this.rBorder[seriesIndex] = this.lBorder[seriesIndex];
                    }
                    //this is to reduce the items for non archived zoom, refresh and start
                    //expected for ZOOM
                    else
                        this.rBorder[seriesIndex] = this.lBorder[seriesIndex];
                }
                //if to reduce only non archived and series is not archived, then dont reduce
                else if (isOnlyNonArchived && !(series.IsNonArchived || this.isThisNonArchivedNona(series.TrendSeriesId, nonArchivedTimelineData))) {
                    isToreduceSeries = false;
                    //as we are skiping the series to reduce the data, we need to increase the index
                    seriesIndex++;
                    //clean the COV data for archived data as we already brought this data from server and we are not reducing this
                    series.Series = [];
                }
                //we dont have series for archive and this is refresh/getData call
                else if (!isOnlyNonArchived) {
                    isToreduceSeries = true;
                }
                if (series != undefined && isToreduceSeries) {
                    //console.log("Border - series border getReducedCovData" + new Date(this.lBorder[seriesIndex]) + "To: " + new Date(this.rBorder[seriesIndex]));
                    let newrBorder: any = this.rBorder[seriesIndex] + this.calculatedInterval;
                    let tempIntervalArray: any[] = [];
                    let intervalIndex = 0;

                    //if missed series has a slice data then  only do update to UI
                    //item should be greater than rBorder but it can not be greater than newrBorder as newrBorder is already a rborder  + interval
                    //following line is commented as it reduction alforithm was failing to calcultate the items those are in misseddata and not yet reduced
                    //CHANGE 1 - this is to resolve as the data loss was happening on pause button
                    //if(series.Series.length > 0 && series.Series[series.Series.length - 1].X.getTime() >= newrBorder){
                    if (series.Series.length > 0)//&& series.Series[series.Series.length - 1].X.getTime() >= this.rBorder[seriesIndex]) 
                    {
                        let itemIndex = 0;
                        //for each missed series item
                        series.Series.forEach(element => {
                            if (this.Interval != undefined && (parseInt(this.Interval) == -2)) {
                                tempIntervalArray.push(element);
                                this.intervalArray.push([intervalIndex, tempIntervalArray.slice(0, tempIntervalArray.length)]);
                                tempIntervalArray.splice(0, tempIntervalArray.length);
                                series.Series.splice(0, tempIntervalArray.length);


                                let diff = element.X.getTime() - this.rBorder[seriesIndex];
                                this.rBorder[seriesIndex] = element.X.getTime();
                                this.lBorder[seriesIndex] = this.lBorder[seriesIndex] + diff;
                                intervalIndex++;
                            }
                            else {
                                //if item is in between rBorder and newrBorder 
                                // or item is last item in missed item series where item == newrBorder
                                if ((this.rBorder[seriesIndex] < element.X.getTime() && element.X.getTime() <= newrBorder)
                                    || (this.rBorder[seriesIndex] < element.X.getTime() && element.X.getTime() == newrBorder && series.Series.length == itemIndex + 1)) {
                                    //push this item to next interval
                                    tempIntervalArray.push(element);

                                    //if element is last item and it is equal to newBorder, then we need to add that element to consider this as new interval
                                    if (this.rBorder[seriesIndex] < element.X.getTime() && element.X.getTime() == newrBorder && series.Series.length == itemIndex + 1) {
                                        this.rBorder[seriesIndex] = newrBorder;
                                        this.lBorder[seriesIndex] = this.lBorder[seriesIndex] + this.calculatedInterval;
                                        newrBorder = newrBorder + this.calculatedInterval;

                                        if (tempIntervalArray.length > 0) {
                                            //finalise the interval array
                                            this.intervalArray.push([intervalIndex, tempIntervalArray.slice(0, tempIntervalArray.length)]);
                                            //remove all items from temp array and missed series item array
                                            tempIntervalArray.splice(0, tempIntervalArray.length);
                                            series.Series.splice(0, tempIntervalArray.length);
                                            intervalIndex++;
                                        }
                                    }
                                }
                                //this condition is to handle the non archived call from zoom, refresh and start
                                //isBorderChanged is added to finalise the interval. once we have added items to  tempIntervalArray by using this condition
                                //then we should go to next else condition for next item
                                else if (!isBorderChanged && isOnlyNonArchived && (series.IsNonArchived || this.isThisNonArchivedNona(series.TrendSeriesId, nonArchivedTimelineData)) && (element.X.getTime() > newrBorder)) {
                                    for (; element.X.getTime() > newrBorder;) {
                                        this.rBorder[seriesIndex] = newrBorder;
                                        //this.lBorder[seriesIndex] = this.lBorder[seriesIndex] + this.calculatedInterval;
                                        newrBorder = newrBorder + this.calculatedInterval;
                                    }
                                    //comments for debugging
                                    isBorderChanged = true;
                                    if (element.X.getTime() <= newrBorder) {
                                        //push this item to next interval
                                        tempIntervalArray.push(element);

                                        //if this is last item in the interval/slice
                                        //if it is not last item, then we will continue and in same slice and newBorder, lborder and rborder will not get changed
                                        if (element.X.getTime() == newrBorder) {
                                            this.rBorder[seriesIndex] = newrBorder;
                                            this.lBorder[seriesIndex] = this.lBorder[seriesIndex] + this.calculatedInterval;
                                            newrBorder = newrBorder + this.calculatedInterval;

                                            if (tempIntervalArray.length > 0) {
                                                //finalise the interval array
                                                this.intervalArray.push([intervalIndex, tempIntervalArray.slice(0, tempIntervalArray.length)]);
                                                //remove all items from temp array and missed series item array
                                                tempIntervalArray.splice(0, tempIntervalArray.length);
                                                series.Series.splice(0, tempIntervalArray.length);
                                                intervalIndex++;
                                            }
                                        }
                                    }
                                }
                                //if item is greater than newBorder, then add add all items from previous interval to interval array
                                //and remove all items from missed series and temp interval array
                                //CHANGE 2. moved border code from outside to tempIntervalArray.length > 0 as it was failing to load data for few dps if there are 10-15 dps
                                else if ((element.X.getTime() > newrBorder)) {
                                    if (tempIntervalArray.length > 0) {
                                        this.rBorder[seriesIndex] = newrBorder;
                                        this.lBorder[seriesIndex] = this.lBorder[seriesIndex] + this.calculatedInterval;
                                        newrBorder = newrBorder + this.calculatedInterval;

                                        //finalise the interval array
                                        this.intervalArray.push([intervalIndex, tempIntervalArray.slice(0, tempIntervalArray.length)]);
                                        //remove all items from temp array and missed series item array								
                                        tempIntervalArray.splice(0, tempIntervalArray.length);
                                        series.Series.splice(0, tempIntervalArray.length);
                                        intervalIndex++;
                                    }
                                    //push this item to next interval
                                    tempIntervalArray.push(element);
                                }
                            }
                            itemIndex++;
                        });
                        let intervalCount = 0;
                        let numberOfSeriesItemsInserted = 0;
                        //for same missed series, add finalised interval min and max to original timelinedata object
                        this.intervalArray.forEach(intervalSubArray => {
                            if (intervalSubArray.length > 1) {
                                let max = undefined;
                                let min = undefined;
                                let maxV = undefined;
                                let minV = undefined;

                                //1. get min and max date and values first
                                intervalSubArray[1].forEach(element => {
                                    if (max == undefined || max.getTime() < element["X"].getTime()) {
                                        max = element["X"];
                                    }
                                    if (min == undefined || min.getTime() > element["X"].getTime()) {
                                        min = element["X"];
                                    }
                                    if (maxV == undefined || maxV < element["Y"]) {
                                        maxV = element["Y"];
                                    }
                                    if (minV == undefined || minV > element["Y"]) {
                                        minV = element["Y"];
                                    }
                                });

                                //2. get min amd max values
                                let minArray = [], maxArray = [];
                                intervalSubArray[1].forEach(element => {
                                    if (minV == element["Y"]) {
                                        minArray.push(element);
                                    }
                                    if (maxV == element["Y"]) {
                                        maxArray.push(element);
                                    }
                                });

                                //3. get date for min and max values
                                if (minArray.length > 0)
                                    min = minArray[0]["X"];
                                if (maxArray.length > 0)
                                    max = maxArray[maxArray.length - 1]["X"];
                                let seriesCount = 0;
                                tData.data.Data.forEach(ser => {
                                    let seriesMinItem = new Series();
                                    seriesMinItem.X = min;
                                    seriesMinItem.Y = minV;
                                    let seriesMaxItem = new Series();
                                    seriesMaxItem.X = max;
                                    seriesMaxItem.Y = maxV;

                                    //if we have new slice latest data, then only insert
                                    //handeled undefined for if there is no history present for dp, then also we need to show the data
                                    //if((series.TrendSeriesId == ser.TrendSeriesId && ser.xMax != undefined && ser.xMax.getTime() <= min.getTime())
                                    if ((series.TrendSeriesId == ser.TrendSeriesId && ser.xMax != undefined && ser.xMax.getTime() <= min.getTime())
                                        || (series.TrendSeriesId == ser.TrendSeriesId && ser.xMax == undefined)) {

                                        //if min and max are duplicate then dont add to timelinedata
                                        if (max != min) {
                                            if (min.getTime() <= max.getTime()) {
                                                ser.Series.push(seriesMinItem);
                                                ser.Series.push(seriesMaxItem);
                                            }
                                            else {
                                                ser.Series.push(seriesMaxItem);
                                                ser.Series.push(seriesMinItem);
                                            }
                                            numberOfSeriesItemsInserted = numberOfSeriesItemsInserted + 2;
                                        }
                                        else {
                                            ser.Series.push(seriesMinItem);
                                            numberOfSeriesItemsInserted++;
                                        }
                                        reducedData.numberOfItemsToRemove[seriesCount] = numberOfSeriesItemsInserted;//this.lBorder[seriesCount];

                                        if (ser.xMax == undefined) {
                                            ser.xMax = max;
                                            ser.xmin = min;
                                        }
                                    }
                                    seriesCount++;
                                });
                            }
                            intervalCount++;
                        });
                        try {
                            //CHANGE 4 it is observed that on pause, data loss is happening and rBorder is not getting updated as required.
                            if (isOnlyNonArchived && (series.IsNonArchived || this.isThisNonArchivedNona(series.TrendSeriesId, nonArchivedTimelineData))) {
                                tData.data.Data.forEach(ser => {
                                    if (series.TrendSeriesId == ser.TrendSeriesId && ser.Series.length > 0 && (ser.Series[ser.Series.length - 1].X) != undefined
                                        && this.rBorder[seriesIndex] < (ser.Series[ser.Series.length - 1].X).getTime()) {
                                        this.rBorder[seriesIndex] = (ser.Series[ser.Series.length - 1].X).getTime();
                                    }
                                });
                            }
                        } catch (error) {

                        }

                        //remove new slices data from this.intervalArray
                        this.intervalArray.splice(0, this.intervalArray.length);
                    }
                    seriesIndex++;
                }
            });

            //remove COV's those are collected and reduced
            this.missedData.forEach(series => {
                tData.data.Data.forEach(reducedSer => {
                    if (series.TrendSeriesId == reducedSer.TrendSeriesId) {
                        for (let itemCount = 0; itemCount < series.Series.length && reducedSer.Series.length > 0;) {
                            //if trend found, remove the COv's those are reduced
                            if (series.Series[0].X < reducedSer.Series[reducedSer.Series.length - 1].X) {
                                series.Series.splice(0, 1);
                            }
                            //if not reduced, then dont remove so that we can reduce it in next reduction
                            else {
                                itemCount++;
                                break;
                            }
                        }
                    }
                });
            });
            //in case of non archived only and if series is non archied, then we need to reuse the lborder.
            //this will be executed in START and REF case only
            if (originalLBorder != undefined) {
                this.lBorder = originalLBorder;
            }
            let bMax;
            //get min
            //changing this as we need to get the oldest one as lborder
            //for lborder we need to get min and for rborder we need to get max
            for (let count = 0; count < this.lBorder.length; count++) {
                if (bMax == undefined || ((isOnlyNonArchived && bMax > this.lBorder[count]) || (!isOnlyNonArchived && bMax < this.lBorder[count]))) {
                    bMax = this.lBorder[count];
                }
            }
            //set same lborder to all
            for (let count = 0; count < this.lBorder.length; count++) {
                this.lBorder[count] = bMax;
            }
            //get max
            bMax = undefined;
            for (let count = 0; count < this.rBorder.length; count++) {
                if (bMax == undefined || bMax < this.rBorder[count]) {
                    bMax = this.rBorder[count];
                }
            }
            //CHANGE 3 added this dummyborder as previously we were keeping same border for all. but this was causing the issue
            //now, we are maintaining the rBorder separate for each trend and because of this it will show all trends
            let dummyRBorder;
            for (let count = 0; count < this.rBorder.length; count++) {
                //this.rBorder[count] = bMax;
                dummyRBorder = bMax;
            }

            reducedData.data = tData.data;
            if (this.Interval != undefined && (parseInt(this.Interval) == -2)) {
                reducedData.isAllItems = true;
            }
            else {
                reducedData.isAllItems = false;
            }
            if (this.xAxisScaleToMaintain === undefined) {
                this.xAxisScaleToMaintain = [];
            }
            if (isToMaintainDuplicateBorders) {
                this.lBorder = duplicateBorders.lBorder;
                this.rBorder = duplicateBorders.rBorder;
                this.xAxisScaleToMaintain = duplicateBorders.xAxisScaleToMaintain;
            }
            else {
                //part of CHANGE 2, used dummyRBorder border instead of rBorder
                let originalScaleDiff = this.xAxisScaleToMaintain[1].getTime() - this.xAxisScaleToMaintain[0].getTime();
                let borderDiff = dummyRBorder - this.lBorder[0];
                //this is to handle the non archived only refresh scale
                if (originalScaleDiff > borderDiff) {
                    for (let count = 0; count < this.lBorder.length; count++) {
                        this.lBorder[count] = dummyRBorder - originalScaleDiff;
                    }
                    // defect 1066402 : commented as zoom range was coming incorrect
                    // if xscale values are manupulated.
                    // this.xAxisScaleToMaintain[0] = new Date(dummyRBorder - originalScaleDiff); //as all lborders are same, we can assign any one from array
                    //this.xAxisScaleToMaintain[1] = new Date(dummyRBorder); //as all lborders are same, we can assign any one from array
                }

            }
            reducedData.borders = this.lBorder;
            reducedData.xAxisScaleToMaintain = this.xAxisScaleToMaintain;
            //reducedData.borders.push(this.rBorder);
        }
        catch (error) {
            this.logger.logError("Reduction Algorithm", "Error while reducing the data/applying the reduction algorithm on COV's: " + error);
        }
        return reducedData;
    }

    private setIntervalForCovReduction(timelinedata: TimelineData) {
        if (timelinedata != undefined) {
            if (!this.isZoomCalled && (this.missedData === undefined || this.missedData.length == 0)) {
                this.missedData = [];
            }
            this.lBorder = [];
            this.rBorder = [];
            let lBorder, rborder;
            timelinedata.Data.forEach(series => {
                if (series != undefined) {
                    if (lBorder == undefined || (series.xMin !== undefined && lBorder.getTime() > series.xMin.getTime())) {
                        lBorder = series.xMin;
                    }
                    if (rborder == undefined || (series.xMax !== undefined && rborder.getTime() < series.xMax.getTime())) {
                        rborder = series.xMax;
                    }
                }
            });

            //this is mainly if there is no history present for all datapoints 
            //then, we dont have broder and we need to calculate
            //if((lBorder == undefined && rborder == undefined) || (lBorder == undefined && rborder != undefined) 
            //|| (lBorder != undefined && rborder == undefined))
            if (this.isDataNotPresent && this.From != undefined && this.To != undefined) {
                // In case of zoom dont change right and left borders
                if(this.isZoomCalled){
                    rborder = this.To;
                    lBorder = this.From;
                } else {
                rborder = new Date(); //new Date(this.To);////15 min old date
                lBorder = new Date(new Date().getTime() - this.scaleToMaintainForNonArchievedData);//new Date(this.From);// //15 min old date
                }
            }

            //if somehow, the xaxis scale is not defined, then we need to push the new rborder and lborder as scale
            if (this.xAxisScaleToMaintain === undefined) {
                this.xAxisScaleToMaintain = [];
                this.xAxisScaleToMaintain.push(lBorder);
                this.xAxisScaleToMaintain.push(rborder);
            }
            timelinedata.Data.forEach(series => {
                if (series.xMin === undefined && lBorder != undefined) {
                    series.xMin = lBorder;
                }
                else if (lBorder === undefined) {
                    series.xMin = new Date();
                    lBorder = series.xMin;
                }
                if (series.xMax === undefined && rborder != undefined) {
                    series.xMax = rborder;
                }
                else if (rborder === undefined) {
                    series.xMax = new Date();
                    rborder = series.xMax;
                }
            });
            let duplicateMissedData = [];
            timelinedata.Data.forEach(series => {
                if (series != undefined) {
                    let missedSeries: TimelineSeries = new TimelineSeries();
                    missedSeries.DataPointName = series.DataPointName;
                    missedSeries.TrendSeriesId = series.TrendSeriesId;
                    missedSeries.IsNonArchived = series.IsNonArchived;
                    missedSeries.Series = [];

                    duplicateMissedData.push(missedSeries);
                    // this.lBorder.push(new Date(this.From));
                    // this.rBorder.push(new Date(this.To));
                    if (this.xAxisScaleToMaintain != undefined) {
                        this.lBorder.push(this.xAxisScaleToMaintain[0].getTime());
                        this.rBorder.push(this.xAxisScaleToMaintain[1].getTime());
                    }
                    else {
                        this.lBorder.push(lBorder == undefined ? series.xMin.getTime() : lBorder.getTime());
                        this.rBorder.push(series.xMax.getTime() - 500);
                    }
                }
            });
            if (this.isZoomCalled) {
                this.isZoomCalled = false;
            }
            else if (this.missedData === undefined || this.missedData.length == 0) {
                this.missedData = duplicateMissedData;
            }
        }

        //THIS IS to set calculatedInterval
        if (this.missedData.length > 0) {
            if (this.Interval == "-2" || this.Interval == -2) {
                this.calculatedInterval = -2;
            }
            else {
                let lBorderDate: Date;
                let rBorderDate: Date;
                //find size of interval in seconds
                if (this.xAxisScaleToMaintain != undefined && this.xAxisScaleToMaintain.length == 2) {
                    lBorderDate = this.xAxisScaleToMaintain[0];
                    rBorderDate = this.xAxisScaleToMaintain[1];
                }
                else {
                    lBorderDate = new Date(this.From);
                    rBorderDate = new Date(this.To);
                }
                let lBorder = lBorderDate.getTime();
                let rBorder = rBorderDate.getTime();
                this.calculatedInterval = (rBorder - lBorder) / parseInt(this.Interval);//secondLastIntIndex * parseInt(this.dataProvider.privateConfig.Intervalparam);
            }
        }
    }
    private getMinMax(series: any, flag: string) {
        let minResult = undefined, maxResult = undefined;
        series.forEach(element => {
            if (flag == 'max' && (maxResult == undefined || (element["X"] != undefined && maxResult.getTime() < element["X"].getTime()))) {
                maxResult = element["X"];
            }
            if (flag == 'min' && (minResult == undefined || (element["X"] != undefined && minResult.getTime() > element["X"].getTime()))) {
                minResult = element["X"];
            }
        });
        if (flag == 'max')
            return maxResult;
        else
            return minResult;
    }
    private sortData(timelinedata: TimelineData) {
        let areAllEmpty = true;
        let xmin: any = [], xmax: any = [], ymin: any = [], ymax: any = [];
        for (let i = 0; i < timelinedata.Data.length; i++) {
            if (timelinedata.Data[i].Series !== undefined && timelinedata.Data[i].Series.length > 0) {
                if (Object.prototype.toString.call(new Date(timelinedata.Data[i].Series[0].X.toString())) === '[object Date]') {
                    timelinedata.Data[i].Series.forEach((d) => {
                        d.X = new Date(d.X);
                    })
                    //Find the Min and Max Time Values
                    timelinedata.Data[i].xMin = this.getMinMax(timelinedata.Data[i].Series, 'min');//d3.min(timelinedata.Data[i].Series, (d: Series, index: number, arr: any) => d.X);
                    timelinedata.Data[i].xMax = this.getMinMax(timelinedata.Data[i].Series, 'max');//d3.max(timelinedata.Data[i].Series, (d: Series, index: number, arr: any) => d.X);
                }
                else {
                    timelinedata.Data[i].Series.forEach((d) => {
                        d.X = new Number(d.X);
                    })

                    // Find the Min and Max Time Values
                    timelinedata.Data[i].xMin = this.getMinMax(timelinedata.Data[i].Series, 'min');//d3.min(this.timelinedata.Data[i].Series, (d: Series, index: number, arr: any) => { return d.X });
                    timelinedata.Data[i].xMax = this.getMinMax(timelinedata.Data[i].Series, 'max');//d3.max(this.timelinedata.Data[i].Series, (d: Series, index: number, arr: any) => { return d.X });
                }

                if (Object.prototype.toString.call(timelinedata.Data[i].Series[0].Y) === '[object Date]') {
                    //this.yIsDateTime = true;
                    timelinedata.Data[i].Series.forEach((d) => {
                        d.Y = new Date(d.Y);
                    })
                    //ymin[i] = this.getMinMax(timelinedata.Data[i].Series, 'min');//d3.min(this.timelinedata.Data[i].Series, (d: Series, index: any, arr: any) => d.Y);
                    //ymax[i] =  this.getMinMax(timelinedata.Data[i].Series, 'max');//d3.max(this.timelinedata.Data[i].Series, (d: Series, index: any, arr: any) => d.Y);
                }
                else {
                    timelinedata.Data[i].Series.forEach((d) => {
                        d.Y = new Number(d.Y);
                    })
                    //ymin[i] = this.getMinMax(timelinedata.Data[i].Series, 'min');//d3.min(this.timelinedata.Data[i].Series, (d: Series, index: any, arr: any) => { return d.Y });
                    //ymax[i] =  this.getMinMax(timelinedata.Data[i].Series, 'max');//d3.max(this.timelinedata.Data[i].Series, (d: Series, index: any, arr: any) => { return d.Y });
                }
                timelinedata.Data[i].Series = timelinedata.Data[i].Series.sort((a: any, b: any) => { return a.X - b.X; });
                areAllEmpty = false;

            }
            else {
                timelinedata.Data[i].IsNonArchived = true;
            }
        }
        if (areAllEmpty) {
            this.isDataNotPresent = true;
            if (this.From != undefined && this.To != undefined) {
                this.scaleToMaintainForNonArchievedData = this.To.getTime() - this.From.getTime();
            }
            // assign new to and from date only if zoom is not called 
            else if (!this.isZoomCalled) {
                let toDate: Date = new Date(Date.now());
                let fromDate: Date = new Date((toDate.getTime() - this.scaleToMaintainForNonArchievedData)); //1 day = 24*60*60*1000
                this.xAxisScaleToMaintain = [];
                this.xAxisScaleToMaintain.push(fromDate);
                this.xAxisScaleToMaintain.push(toDate);
            }
        }
        //console.log("Scale - Provider Sort " + this.xAxisScaleToMaintain[0] + "To: " + this.xAxisScaleToMaintain[1]);
        //timelinedata = undefined;
        //do this for initial load only and not on pause, start and zoom
        //if(this.lBorder.length == 0 && this.calculatedInterval == undefined){
        this.setIntervalForCovReduction(timelinedata);
        //}
        //if there is some undefined series(means no data), then remove that series from the list
        if (timelinedata != undefined) {
            for (let i = 0; i < timelinedata.Data.length; i++) {
                if (timelinedata.Data[i] == undefined) {
                    timelinedata.Data.splice(i, 1);
                    i--;
                }
            }
        }
        return timelinedata;
    }
    // this will set the zoom attributes for the trend series.
    zoom(zoomFrom: any, zoomTo: any) {

        // reset timeline
        this.timelineData = new TimelineData;
        this.timelineData.Data = []

        var intervalFromConfig = Number(this.config.Intervalparam);

        //get total records in the sample
        var totalRecords = this.GetRecordsCount(zoomFrom, zoomTo);

        if (intervalFromConfig && (totalRecords < intervalFromConfig)) {
            this.Interval = (Math.floor(totalRecords / 2)).toString();
        }
        else if (intervalFromConfig) {
            this.Interval = intervalFromConfig.toString();
        }
        else {
            this.Interval = this.DefaultInterval.toString();
        }

        this.logger.logInfo('Interval for the trendseries is', this.Interval)

        this.From = zoomFrom;
        this.To = zoomTo;
        this.isZoomCalled = true;
        this.xAxisScaleToMaintain = [];
        this.xAxisScaleToMaintain[0] = this.From;
        this.xAxisScaleToMaintain[1] = this.To;
        //console.log("Scale - Provider Zoom " + this.From + "To: " + this.To);
        this.initializeConfig();
        this.callGetSeriesDataAsync();
    }

    // initialze the provider config setting.
    private initializeConfig() {
        if (this.config.seriesidsparam) {

            let sids = this.config.seriesidsparam;
            if (sids)
                this.seriesids = sids.split(',');
            else
                this.widget.Draw(null);
        }

        if (this.config.seriesparam) {
            this.seriesid = this.config.seriesparam;
        }

        if (this.config.objparam) {
            this.trendobj = this.config.objparam;
        }

        if (this.From == undefined && this.config.Fromparam) {
            this.From = this.config.Fromparam;
        }
        this.isLive = true;
        if (this.To == undefined && (this.config.Toparam != undefined)) {
            this.To = this.config.Toparam;
            this.isLive = false;
         } 
        // defect 1070698: Because of default values load data for
        // days was not working so removed this code to set default values.
        //else if (this.To == undefined) {
        //     this.To = new Date(Date.now());
        //     this.config.Toparam = this.To;
        //     this.isLive = true;
        // }
        //load data for 24 hours while running application in browser
        // if (this.From == undefined && this.To != undefined) {
        //     this.From = new Date((this.To.getTime() - 86400000)); //1 day = 24*60*60*1000
        //     this.xAxisScaleToMaintain = [];
        //     this.xAxisScaleToMaintain.push(this.From);
        //     this.xAxisScaleToMaintain.push(!isNaN(Date.parse(this.To)) ? this.To : new Date(this.To));
        // }
        if (this.config.Intervalparam && Number(this.config.Intervalparam) && this.config.Intervalparam != 0) {
            this.Interval = this.config.Intervalparam;
        }

        if (this.config.LoadDataForDaysparam && Number(this.config.LoadDataForDaysparam) && this.config.LoadDataForDaysparam != 0) {
            this.LoadDataForDays = this.config.LoadDataForDaysparam;
        }
        if (this.config.Intervalparam && Number(this.config.Intervalparam) && this.config.Intervalparam != 0) {
            this.Interval = this.config.Intervalparam;
        }
        else {
            this.Interval = this.DefaultInterval;
        }
    }

    // Start the get data.
    private Start() {
        try {
            if (((!this.From && !this.To) || (this.isInvalidStringParam(this.From) && this.isInvalidStringParam(this.To))) && this.LoadDataForDays == 0) {
                // we have done chaining of the Observables via 2 fork joins 
                // first we will get borders for all points,then we will get the series data

                // 1. First get the borders
                let forkjoinGetBorder = [];
                this.seriesids.forEach(id => {
                    forkjoinGetBorder.push(this.readTrendSeriesBorders(id));
                });
                forkJoin<any>(forkjoinGetBorder).subscribe((border:any) => {
                    border.forEach((s:any)=> {
                        this.logger.logInfo("TrendSeries border for point '" + s.LeftBorder + "' is ", s.RightBorder);
                        if (this.LBorder === undefined || (this.LBorder > s.LeftBorder))
                            this.LBorder = s.LeftBorder;
                        if (this.RBorder === undefined || (this.RBorder < s.RightBorder))
                            this.RBorder = s.RightBorder;
                    });
                    this.logger.logInfo("readTrendSeriesBorders", "Left and Right Border for all trend points is " + this.LBorder + " and " + this.RBorder);

                    // 2. Now get the series data for given borders
                    this.callGetSeriesDataAsync();

                });
            }
            else {
                // Get the series data directly as from and to are available
                this.callGetSeriesDataAsync();
            }
        }
        catch (error) {
            this.logger.logError('TrendSeriesDataProvider', "Error:" + error);
            this.widget.Draw(null);
        }
    }

    // to call the get data method in new fork
    private callGetSeriesDataAsync() {
        var idx: number = 0;
        try {
            if (typeof this.seriesids !== 'undefined' && this.seriesids.length > 0) {
                let timelineDatatemp: TimelineData = new TimelineData;
                timelineDatatemp.Data = [];
                let forkjoinReadSeries = [];
                this.seriesids.forEach(id => {
                    forkjoinReadSeries.push(this.readSeriesAsync(id));
                });
                forkJoin<any>(forkjoinReadSeries).subscribe((series:any) => {
                    series.forEach((s:any) => {
                        if (s != null && s != undefined) {
                            this.logger.logInfo("TrendSeries data length for point:'" + s.DataPointName.toString() + "' is ", s.Series.length.toString());
                            timelineDatatemp.Data.push(s);
                        }
                    });
                    timelineDatatemp = this.sortData(timelineDatatemp);
                    let data = { timelineData: timelineDatatemp, isLive: this.isLive, from: this.From, to: this.To, isDataNotPresent: this.isDataNotPresent, xAxisScaleToMaintain: this.xAxisScaleToMaintain, cachedDataToMaintain: this.cachedDataToMaintain };
                    this.widget.Draw(data);
                    this.widgetDrawn = true;
                })
            }
            else if (!this.seriesid) {
                this.readTrendSeriesId();
            }
            else {
                this.readTrendSeries();
            }
        }
        catch (error) {
            this.logger.logError('TrendSeriesDataProvider', "Error:" + error);
            this.widget.Draw(null);
        }
    }

    // Gets the url for trend series data API WSI call.
    private getTrendSeriesUrl(): string {
        let baseUrl = this.dashboardConfig.getBaseUrl();
        let interval = this.Interval;
        let url: string = baseUrl + "/api/trendseries/" + this.seriesid;
        if (!this.From && !this.To) {
            return url;
        }
        else if (!(new Date(this.From).toString() === "Invalid Date") && !(new Date(this.To).toString() === "Invalid Date")) {
            this.From = new Date(this.From);
            this.To = new Date(this.To);
            this.xAxisScaleToMaintain = [];
            this.xAxisScaleToMaintain.push(this.From);
            this.xAxisScaleToMaintain.push(this.To);
            if (Object.prototype.toString.call(this.From) === '[object Date]' && Object.prototype.toString.call((this.To) === '[object Date]'))
                url = url + '?from=' + this.From.toISOString() + '&to=' + this.To.toISOString();
        }
        else {
            this.logger.logWarning('TrendSeriesDataProvider', "Incorrect format of parameter/s From and/or To date.")
            return null;
        }

        if (this.Interval > 0) {
            if (url.indexOf('?') == -1)
                url = url + '?' + 'intervals=' + this.Interval.toISOString();
            else
                url = url + '&' + 'intervals=' + this.Interval.toISOString();
        }
        return url;
    }

    // Gets the url for trend series data API WSI call by series.
    private getUrlForSeries(seriesID: string): string {

        let baseUrl = this.dashboardConfig.getBaseUrl();
        let url: string = baseUrl + "/api/trendseries/" + seriesID;

        if ((!this.From && !this.To) || (this.isInvalidStringParam(this.From) && this.isInvalidStringParam(this.To))) {
            if (this.LoadDataForDays == 0) {
                //if no from and to date given, then load data for 24 hours while running application in desigo cc client
                if (this.isInvalidStringParam(this.From) && this.isInvalidStringParam(this.To)) {
                    this.To = new Date(Date.now());
                    this.From = new Date((this.To.getTime() - 86400000)); //1 day = 24*60*60*1000
                    this.isLive = true;
                    url = url + '?from=' + this.From.toISOString() + '&to=' + this.To.toISOString();
                    this.xAxisScaleToMaintain = [];
                    this.xAxisScaleToMaintain.push(this.From);
                    this.xAxisScaleToMaintain.push(this.To);
                }
                //else do load entire data
                else {
                    url = url + '?from=' + this.LBorder + '&to=' + this.RBorder;
                    this.xAxisScaleToMaintain = [];
                    this.xAxisScaleToMaintain.push(new Date(this.LBorder));
                    this.xAxisScaleToMaintain.push(new Date(this.RBorder));
                }
            }
            else {
                this.To = new Date(Date.now());
                this.isLive = true;
                this.From = new Date(Date.now() - this.LoadDataForDays * 24 * 60 * 60 * 1000) 
                if (Object.prototype.toString.call(this.From) === '[object Date]' && Object.prototype.toString.call((this.To) === '[object Date]'))
                    url = url + '?from=' + this.From.toISOString() + '&to=' + this.To.toISOString();
                this.xAxisScaleToMaintain = [];
                this.xAxisScaleToMaintain.push(this.From);
                this.xAxisScaleToMaintain.push(this.To);
            }
        }
        else if (!(new Date(this.From.toString().replace("-", " ")).toString() === "Invalid Date") && !(new Date(this.To.toString().replace("-", " ")).toString() === "Invalid Date")) {
            this.From = new Date(this.From.toString().replace("-", " "));
            this.To = new Date(this.To.toString().replace("-", " "));
            this.xAxisScaleToMaintain = [];
            this.xAxisScaleToMaintain.push(this.From);
            this.xAxisScaleToMaintain.push(this.To);
            if (Object.prototype.toString.call(this.From) === '[object Date]' && Object.prototype.toString.call((this.To) === '[object Date]'))
                url = url + '?from=' + this.From.toISOString() + '&to=' + this.To.toISOString();
        }
        else {
            this.logger.logWarning('TrendSeriesDataProvider', "Incorrect format of parameter/s From and/or To date.")
            return null;
        }

        if (this.Interval > 0) {
            let invt: string = this.Interval.toString();
            if (url.indexOf('?') == -1)
                url = url + '?' + 'intervals=' + invt;
            else
                url = url + '&' + 'intervals=' + invt;
        }


        return url;
    }

    // Gets the trend series border data.
    private readTrendSeriesBorders(tseriesid: any): Observable<Border> {

        let result = Observable.create(observer => {

            if (!tseriesid)
                observer.empty();

            let baseUrl = this.dashboardConfig.getBaseUrl();
            let url: string = baseUrl + "/api/trendseries/" + tseriesid + "/borders";

            //get token
            let token: any = this.authService.getToken();
            let headers: HttpHeaders = new HttpHeaders({ "Accept": "application/json", "Authorization": "Bearer " + token });
            // headers.append("Accept", "application/json");      
            //  headers.append("Authorization", "Bearer " + token);
            this.http.get(url, {
                headers: headers
            }).subscribe((res: HttpResponse<any>) => {
                try {
                    this.logger.logInfo("TrendSeriesDataProvider", "Received response for get border.");
                    if (!res) {
                        this.processError(new Error("Bad response status: " + res));
                        observer.complete();
                    }
                    else {

                        let border: Border = new Border;
                        let body: any = res;//.json();

                        border.LeftBorder = body.From;
                        border.RightBorder = body.To;

                        observer.next(border);
                        observer.complete();
                    }
                }
                catch (error) {
                    this.logger.logError("TrendSeriesDataProvider", "Error while processing response : " + error);
                    observer.next(null);
                    observer.complete();
                }

            }, this.processError);
        })
        return result;
    }

    // Gets the trend series data in parallel.
    private readSeriesAsync(seriedId: string): Observable<TimelineSeries> {

        let result = Observable.create(observer => {

            if (!seriedId)
                return empty();

            let url = this.getUrlForSeries(seriedId);

            let token: any = this.authService.getToken();
            let headers: HttpHeaders = new HttpHeaders({ "Accept": "application/json", "Authorization": "Bearer " + token, "Access-Control-Allow-Origin": "*" });
            // headers.append("Accept", "application/json");
            //  headers.append("Access-Control-Allow-Origin", "*");
            // headers.append("Authorization", "Bearer " + token);
            this.http.get(url, {
                headers: headers
            }).subscribe((res: HttpResponse<any>) => {
                try {

                    if (!res) {
                        this.logger.logInfo("TrendSeriesDataProvider", "Response not found for : " + seriedId);
                        // To show point description 
                        if (seriedId && seriedId != null) {

                            let seriesCollectiontemp: TimelineSeries = new TimelineSeries;
                            seriesCollectiontemp.Series = [];
                            seriesCollectiontemp.DataPointName = seriedId;
                            seriesCollectiontemp.TrendSeriesId = seriedId;
                            if (!this.widgetDrawn) {
                                this.getPointDescription(seriedId, headers, seriesCollectiontemp, observer);
                            } else {
                                const dataPoint: KeyValue = this.dataPointName.find(x => x.Key == seriedId);
                                seriesCollectiontemp.DataPointName = dataPoint.Value;
                                seriesCollectiontemp.Unit = dataPoint.Unit;
                                seriesCollectiontemp.Resolution = dataPoint.Resolution;
                                observer.next(seriesCollectiontemp);
                                observer.complete();
                            }
                        }
                    }
                    else {
                        let timelineData = new TimelineData;
                        timelineData.Data = [];
                        let seriesCollection: TimelineSeries = new TimelineSeries;

                        let body: any = res;//.json();
                        if (body && body.Series) {
                            seriesCollection.Series = [];
                            for (var i = 0; i < body.Series.length; i++) {
                                let obj: any = body.Series[i];
                                if (obj) {
                                    let x: any = obj.Timestamp;
                                    let y: any = obj.Value;

                                    if (x !== undefined && y !== undefined) {
                                        let series = new Series();
                                        series.X = x;
                                        series.Y = y;
                                        seriesCollection.Series.push(series);
                                    }
                                }
                            }
                            seriesCollection.DataPointName = body.SeriesPropertyId;
                            seriesCollection.TrendSeriesId = body.Id;
                            if (body.SeriesPropertyId && body.SeriesPropertyId != null && !this.widgetDrawn) {


                                this.getPointDescription(seriedId, headers, seriesCollection, observer);
                            }
                            else {
                                const dataPoint: KeyValue = this.dataPointName.find(x => x.Key == seriedId);
                                seriesCollection.DataPointName = dataPoint.Value;
                                seriesCollection.Unit = dataPoint.Unit;
                                seriesCollection.Resolution = dataPoint.Resolution;
                                observer.next(seriesCollection);
                                observer.complete();
                            }
                        }
                    }
                }
                catch (ex) {
                    this.logger.logError("TrendSeriesDataProvider", "Error while processing response : " + ex);
                    observer.next(null);
                    observer.complete();
                }
            }, (error) => {
                let errMsg: any = (error && error.message) ? error.message : "Server error";
                if (this.logger)
                    this.logger.logError("TrendSeriesDataProvider", "Error in received from service: " + errMsg);
                observer.next(null);
                observer.complete();
            });
        })
        return result;
    }
    private getPointDescription(seriedId: string, headers: HttpHeaders, seriesCollection: TimelineSeries, observer: any) {
        var seriesCollectionDataPointName = seriesCollection.DataPointName;;
        let systemId = 0;
        let seriesIds: any[] = [];
        let baseURL = this.dashboardConfig.getBaseUrl();
        let showDeviceDescription = this.widget.Config.LabelConfiguration && this.widget.Config.LabelConfiguration.DisplayDeviceDescriptor ? this.widget.Config.LabelConfiguration.DisplayDeviceDescriptor : undefined;
        let showPropertyDescriptor = this.widget.Config.LabelConfiguration && this.widget.Config.LabelConfiguration.DisplayPropertyDescriptor ? this.widget.Config.LabelConfiguration.DisplayPropertyDescriptor : showDeviceDescription ? undefined : true;
        let forkJoins: Observable<any>[] = [];
        let systemName = seriedId.split(':')[0];
        systemId = this.dashboardConfig.hasSystemData && (this.dashboardConfig.systemData.find(x => x.Name === systemName)) ? (this.dashboardConfig.systemData.find(x => x.Name === systemName)).Id : systemId;
        seriesIds.push(seriedId);
        if (showDeviceDescription) {
            // let requestOptions = new RequestOptions({ headers: headers });
            let descriptorUrl = baseURL + "/api/systembrowser/" + systemId;
            forkJoins.push(this.http.post(descriptorUrl, seriesIds, { headers: headers }).pipe(map(data => data)));
        }

        let propertyUrl = baseURL + '/api/properties/' + seriesIds
        forkJoins.push(this.http.get(propertyUrl, {
            headers: headers
        }).pipe(map(data => data)))

        forkJoin(forkJoins).subscribe(result => {
            if (result && result.length > 1) {
                let data1 = result[0];
                let data2 = result[1];
                let propertyDescriptor = "";
                this.unit = seriesCollection.Unit = data2 && data2.length > 0 && data2[0].Properties && data2[0].Properties[0].UnitDescriptor ? data2[0].Properties[0].UnitDescriptor : "";
                this.resolution = seriesCollection.Resolution = data2 && data2.length > 0 && data2[0].Properties && data2[0].Properties[0].Resolution ? data2[0].Properties[0].Resolution : 0;
                if (data2 && data2.length > 0 && data2[0].Properties && data2[0].Properties[0].Descriptor) {
                    propertyDescriptor = data2[0].Properties[0].Descriptor;
                } else if (showPropertyDescriptor) {
                    propertyDescriptor = seriesCollectionDataPointName;
                    this.logger.logInfo("TrendSeriesDataProvider", "Unable to get property description for " + seriedId)
                }
                let deviceDescriptor = "";
                if (data1 && data1.length > 0 && data1[0].Nodes.length > 0 && data1[0].Nodes[0].Descriptor) {
                    deviceDescriptor = data1[0].Nodes[0].Descriptor;
                } else {
                    deviceDescriptor = seriesCollectionDataPointName;
                    this.logger.logInfo("TrendSeriesDataProvider", "Unable to get point/device description for " + seriedId)
                }
                seriesCollection.DataPointName = deviceDescriptor + (showPropertyDescriptor ? " [" + propertyDescriptor + "]" : "");
                var val: KeyValue = { Key: seriedId, Value: seriesCollection.DataPointName, Unit: this.unit, Resolution: this.resolution }
                this.dataPointName.push(val);
            }
            else {
                let data = result[0];
                let descriptor = "";
                this.unit = seriesCollection.Unit = data && data.length > 0 && data[0].Properties && data[0].Properties[0].UnitDescriptor ? data[0].Properties[0].UnitDescriptor : "";
                this.resolution = seriesCollection.Resolution = data && data.length > 0 && data[0].Properties && data[0].Properties[0].Resolution ? data[0].Properties[0].Resolution : 0;
                if (showDeviceDescription) {
                    if (data && data.length > 0 && data[0].Nodes && data[0].Nodes.length > 0 && data[0].Nodes[0].Descriptor) {
                        descriptor = data[0].Nodes[0].Descriptor;
                        seriesCollection.DataPointName = descriptor;
                        var val: KeyValue = { Key: seriedId, Value: seriesCollection.DataPointName, Unit: this.unit, Resolution: this.resolution }
                        this.dataPointName.push(val);
                    } else {
                        this.logger.logInfo("TrendSeriesDataProvider", "Unable to get property/device description for " + seriedId)
                    }
                }
                else if (showPropertyDescriptor) {
                    if (data && data.length > 0 && data[0].Properties && data[0].Properties[0].Descriptor) {
                        let descriptor = data[0].Properties[0].Descriptor;
                        seriesCollection.DataPointName = descriptor;
                        var val: KeyValue = { Key: seriedId, Value: seriesCollection.DataPointName, Unit: this.unit, Resolution: this.resolution }
                        this.dataPointName.push(val);
                    } else {
                        this.logger.logInfo("TrendSeriesDataProvider", "Unable to get property/device description for " + seriedId)
                    }
                }
            }
            if (observer != undefined) {
                observer.next(seriesCollection);
                observer.complete();
            }
        }, error => {
            this.logger.logError('TrendSeriesDataProvider', "unable to get dpid for:" + error);
            if (observer != undefined) {
                observer.next(seriesCollection);
                observer.complete();
            }
            this.processError;
        });
    }

    // Gets the trend series data.
    private readTrendSeriesId(): void {
        if (!this.trendobj) {
            this.logger.logError('TrendSeriesDataProvider', "unable to fetch data.");
            this.widget.Draw(null);
        }

        let baseUrl = this.dashboardConfig.getBaseUrl();
        let url: string = baseUrl + "/api/trendseriesinfo/" + this.trendobj;

        //get token
        let token: any = this.authService.getToken();
        let headers: HttpHeaders = new HttpHeaders({ "Accept": "application/json", "Authorization": "Bearer " + token });
        //  headers.append("Accept", "application/json");
        //headers.append("Access-Control-Allow-Origin", "*");
        //  headers.append("Authorization", "Bearer " + token);
        this.http.get(url, {
            headers: headers
        }).subscribe((res: HttpResponse<any>) => {
            try {
                this.logger.logInfo("TrendSeriesDataProvider", "Received response for readTrendSeriesId");
                if (!res) {
                    this.processError(new Error("Bad response status"));
                }
                else {
                    let body: any = res;//.json();
                    //take first series id
                    let seriesInfo = body[0];
                    if (seriesInfo && seriesInfo.TrendseriesId) {
                        this.seriesid = seriesInfo.TrendseriesId;
                        this.readTrendSeries();
                    }
                }
            }
            catch (error) {
                this.logger.logError("TrendSeriesDataProvider", "Error while processing response : " + error);
                this.widget.Draw(null);
            }

        }, this.processError);
    }

    // Gets the trend series data.
    private readTrendSeries(): void {
        if (!this.seriesid)
            return;

        let url = this.getTrendSeriesUrl();
        //get token
        if (url != null) {
            let token: any = this.authService.getToken();
            let headers: HttpHeaders = new HttpHeaders({ "Accept": "application/json", "Authorization": "Bearer " + token, "Access-Control-Allow-Origin": "*" });
            //  headers.append("Accept", "application/json");
            //  headers.append("Access-Control-Allow-Origin", "*");
            // headers.append("Authorization", "Bearer " + token);
            this.http.get(url, {
                headers: headers
            }).subscribe((res: HttpResponse<any>) => {
                try {
                    this.logger.logInfo("TrendSeriesDataProvider", "Received response for readTrendSeries");
                    if (!res) {
                        this.processError(new Error("Bad response status"));
                    }
                    else {

                        let body: any = res;//.json();
                        if (body && body.Series) {
                            let seriesCollection: TimelineSeries = new TimelineSeries;
                            seriesCollection.Series = [];
                            if (this.timelineData === undefined) {
                                this.timelineData = new TimelineData;
                                this.timelineData.Data = [];
                            }
                            for (var i = 0; i < body.Series.length; i++) {
                                let obj: any = body.Series[i];
                                if (obj) {
                                    let x: any = obj.Timestamp;
                                    let y: any = obj.Value;
                                    if (x !== undefined && y !== undefined) {
                                        let series = new Series();
                                        series.X = x;
                                        series.Y = y;
                                        seriesCollection.Series.push(series);
                                    }
                                }
                            }

                            if (body.SeriesPropertyId && body.SeriesPropertyId != null && !this.widgetDrawn) {

                                this.getPointDescription(body.SeriesPropertyId, headers, seriesCollection, undefined);

                                this.timelineData.Data.push(seriesCollection);
                                this.logger.logInfo("TrendSeriesDataProvider", "Call for drawing widget is initiated");
                                this.timelineData = this.sortData(this.timelineData);
                                let data = { timelineData: this.timelineData, isLive: this.isLive, from: this.From, to: this.To, isDataNotPresent: this.isDataNotPresent, xAxisScaleToMaintain: this.xAxisScaleToMaintain, cachedDataToMaintain: this.cachedDataToMaintain };
                                this.widget.Draw(data);
                            }

                        }
                    }
                }
                catch (error) {
                    this.logger.logError("TrendSeriesDataProvider", "Error while processing response : " + error);
                    this.widget.Draw(null);
                }
            }, this.processError);
        } else {
            this.widget.Draw(null);
        }
    }

    // Estimates the trend series data record count in given range.
    private GetRecordsCount(fromDate: string, toDate: string): number {
        //Get seconds in a day
        var unit_seconds = 60 * 60 * 24;

        // Convert both dates to milliseconds
        var date_from_ms = Date.parse(fromDate);
        var date_to_ms = Date.parse(toDate);

        if (date_from_ms && date_to_ms) {
            // Calculate the difference in milliseconds
            var difference_ms = date_to_ms - date_from_ms;

            // Convert back to days and return
            return Math.round(difference_ms / unit_seconds);
        }
        return this.DefaultInterval * 2;
    }
    // check if parameter starts or ends with $ // subsitutable parameter 
    private isInvalidStringParam(teststring: string): boolean {
        return (teststring.length > 0 && (teststring.indexOf('$') == 0) && (teststring.lastIndexOf('$') == teststring.length - 1));
    }

    // Error processing.
    private processError(error: any) {
        let errMsg: any = error.message || "Server error";
        this.logger.logError("TrendSeriesDataProvider", errMsg);
        if (this.widget)
            this.widget.Draw(null);
    }

    dispose(): void {

    }
}